/**
 * Dealing Animation Configuration
 *
 * Timing values for round-robin card dealing animation.
 *
 * @see docs/systems/animations/GAME_START_ANIMATION.md - Rules and specs
 * @see tasks/active/T18_ROUND_ROBIN_DEALING_IMPL.md - Implementation
 */

export const DEALING_CONFIG = {
  /**
   * Time for a single card to fly from deck to seat (ms)
   * This is the animation duration per card
   */
  cardFlightDuration: 300,

  /**
   * Delay between dealing cards to consecutive seats (ms)
   * T=0: deal to seat 1, T=stagger: deal to seat 2, etc.
   * Lower = faster dealing, higher = more dramatic
   */
  cardStaggerDelay: 100,

  /**
   * Pause between Round 1 and Round 2 (ms)
   * After all players get card 1, wait this long before dealing card 2s
   */
  roundGapDelay: 150,

  /**
   * Arc height for card flight path (px)
   * Higher = more pronounced arc, 0 = straight line
   */
  arcHeight: 40,
};
